import React, { useEffect, useCallback } from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import _get from 'lodash/get';
import { currentUserSelectors } from '@lifesize/nucleus';
import PageLayout from 'layouts/PageLayout/PageLayout';
import { hidePermission, showOnboarding } from 'actions/Onboarding';
import buddyIcon from 'assets/images/buddy_128x128.png';
import { JOIN_MODAL } from 'constants/JoinModal';
import { FIRST_TIME_USER_SETTING } from 'constants/UserSettings';
import classes from './GetPermission.module.scss';

const messages = defineMessages({
  lifesize: {
    id: 'companyName',
    defaultMessage: 'Lifesize'
  },
  allow: {
    id: 'allow',
    defaultMessage: 'Allow'
  }
});

interface Props {
  intl: { formatMessage: Function };
}

const GetPermission = (props: Props) => {
  const { intl } = props;
  const dispatch = useDispatch();
  const firstTimeUser = useSelector((state) => {
    const currentUser = currentUserSelectors.myInfo(state);
    return _get(currentUser, ['userSettings', FIRST_TIME_USER_SETTING]);
  });
  const showPermissionPage = useSelector((state) => _get(state, 'app.modal.visibleComponent') !== JOIN_MODAL);

  const handleShowOnboarding = useCallback(() => dispatch(showOnboarding()), [dispatch]);

  useEffect(() => {
    if (firstTimeUser) {
      handleShowOnboarding();
    }
  }, [handleShowOnboarding, firstTimeUser]);

  useEffect(() => {
    // if get permissions ever closes, we never show it again
    return () => {
      dispatch(hidePermission());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageLayout className={showPermissionPage ? '' : classes.hiddenPermission}>
      <section className={classes.permissionContainer}>
        <div className={classes.imageSorter}>
          <img src={buddyIcon} alt={intl.formatMessage(messages.lifesize)} />
        </div>
        {firstTimeUser ? (
          <h1 className={classes.firstTimeTitle}>
            <FormattedMessage id="components.getPermission.title" defaultMessage="Get Started" />
          </h1>
        ) : (
          <div className={classes.emptyTitle} />
        )}
        <div className={classes.permissionText}>
          <div>
            {firstTimeUser ? (
              <FormattedMessage
                id="components.getPermission.instructions"
                defaultMessage="First, we need to access your camera and microphone."
              />
            ) : (
              <FormattedMessage
                id="components.getPermission.repeatInstructions"
                defaultMessage="We've detected that you have not yet allowed Lifesize to access your camera and microphone."
              />
            )}
            {firstTimeUser ? null : <div className={classes.emptyDivider} />}
          </div>
          <div>
            <FormattedMessage
              id="components.getPermission.instructionsAllow"
              defaultMessage="Please click {allow} to get started with Lifesize."
              values={{
                allow: <b>{intl.formatMessage(messages.allow)}</b>
              }}
            />
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default injectIntl(GetPermission);
